import { DeviceTypes, } from "../../config/documents/HardwareConfig";
import { IOnoffable, IProbe, PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDeviceOnOffable from "./base-onoffable";
import { DisplayProcessingLogics, StatesToDisplayItem, PoolDeviceCriticalDesiredActual } from "../Types";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class ChlorineSensor extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable, IProbe {
    OnOffIdentifier = criticalFieldIdentifiers.OnOff;
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.CHLORINESENSOR;
    static Icon = "sensor-cl";
    static minAutoFilterVersion = 32;
    static PickerTitle = Locale.gettext("Chlorine Sensor");

    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];

        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }

        return fields;
    }

    getInformationFields(): StatesToDisplayItem[] {
        let order = 0;
        const fields = [];

        {
            const common = {
                DisplayName: "Sensor Value",
                DisplayNameShort: "Value",
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.PPM,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push(Object.assign({ Name: PoolsideDaemonDeviceStateNames.RawValue }, common));
        }
        {
            const common = {
                DisplayName: "Adjusted Value",
                DisplayNameShort: "Adjusted",
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.PPM,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push(Object.assign({ Name: PoolsideDaemonDeviceStateNames.Value }, common));
        }
        {
            const common = {
                DisplayName: "Reading",
                DisplayNameShort: "Reading",
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.MV,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push(Object.assign({ Name: PoolsideDaemonDeviceStateNames.ChlorineMv }, common));
        }


        return fields;
    }

    isReadyToCalibrate(): boolean {
        return !!this.getDeviceState(PoolsideDaemonDeviceStateNames.CalibrationReady)?.value;
    }

    isCalibrated(): boolean {
        /** @todo */
        return false;
    }

}


export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    ChlorineMv = "ChlorineMv",
    CalibrationReady = "CalibrationReady",
    ChlorineCalibrationData = "ChlorineCalibrationData",
    PowerState = "PowerState",
    RawValue = "RawValue",
    TemperatureCalibrationData = "TemperatureCalibrationData",
    Value = "Value",
}
